import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const StyledTitleBanner = styled.div`
  display: flex;

  width: 100%;
  max-height: 1080px;

  background-color: #f8f8f8;
  left: 0px;
  margin-top: -200px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  padding-top: 24px;

  & * {
    font-family: Pretendard !important;
    font-display: swap;
  }

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding-top: 64px;
    max-height: 964px;
    margin-top: -200px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding-top: 96px;
    max-height: 1280px;
    margin-top: -200px;
  }
`;

export const CardLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 32px;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    gap: 16px;
  }
`;

export const Card = styled.div<{ w: number; img: string; index: number; bgColor?: string }>`
  ${({ img }) => img && `background-image : url(${img});`}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: darken;
  border-radius: 16px;
  border: 1px solid var(--border-translucent-light, rgba(0, 0, 0, 0.08));
  padding: 32px;
  display: flex;

  position: relative;

  background-color: ${({ bgColor }) => bgColor || '#f8f8f8'};

  ${({ w, index }) => index === 1 && `width : 100%; aspect-ratio : 1232 / 600 ; max-width : 1232px;`}

  ${({ w, index }) => index === 2 && `width : calc(50% - 16px); aspect-ratio : 600 / 600 ;`}



    ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    ${({ w, index }) => index === 1 && `width : 100%; aspect-ratio : 912 / 500 ; max-width : 912px;`}

    ${({ w, index }) => index === 2 && `width : calc(50% - 16px); aspect-ratio : 440 / 500 ;`}
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 24px;
    width: 100%;
    aspect-ratio: 361 / 400;

    ${({ w, index }) => index === 1 && `max-width : 100%;`}
  }
`;

export const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(42, 112, 240, 0.6); /* 2A70F0 60% */
  backdrop-filter: blur(4px); /* 배경 블러 효과 */
  border-radius: 16px;
  z-index: 1;
`;

export const CardDesc = styled.div<{ gap?: string }>`
  z-index: 3;
  position: absolute;
  inset: 0;
  padding: ${({ gap }) => (gap ? `${gap}px;` : '48px;')};

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 32px;
  }
`;

/* 오른쪽‑아래 + 버튼 */
export const ToggleBtn = styled.img`
  position: absolute;
  right: 24px;
  bottom: 24px;

  width: 40px;
  height: 40px;

  object-fit: cover;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;

  &:focus {
    outline: none;
  }
`;
